"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AerialMappers = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const LogHelper_1 = require("../../LogHelper");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Card_1 = require("../Card");
class AerialMappers extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.AERIAL_MAPPERS,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: '213',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add floater to ANY card.', (be) => {
                        be.empty().startAction.floaters(1).asterix();
                    }).br;
                    b.or(Size_1.Size.SMALL).br;
                    b.action('Spend one floater here to draw 1 card.', (be) => {
                        be.floaters(1).startAction.cards(1);
                    });
                }),
                victoryPoints: 1,
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    getVictoryPoints() {
        return 1;
    }
    action(player) {
        const floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        const opts = [];
        if (floaterCards.length === 1 && this.resourceCount === 0) {
            player.addResourceTo(this, { qty: 1, log: true });
            return undefined;
        }
        const addResourceToSelf = new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => {
            player.addResourceTo(this, { qty: 1, log: true });
            return undefined;
        });
        const addResource = new SelectCard_1.SelectCard('Select card to add 1 floater', 'Add floater', floaterCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
        const spendResource = new SelectOption_1.SelectOption('Remove 1 floater on this card and draw a card', 'Remove floater', () => {
            this.resourceCount--;
            LogHelper_1.LogHelper.logRemoveResource(player, this, 1, 'draw a card');
            player.drawCard();
            return undefined;
        });
        if (this.resourceCount > 0) {
            opts.push(spendResource);
            floaterCards.length === 1 ? opts.push(addResourceToSelf) : opts.push(addResource);
        }
        else {
            return addResource;
        }
        return new OrOptions_1.OrOptions(...opts);
    }
}
exports.AerialMappers = AerialMappers;
//# sourceMappingURL=AerialMappers.js.map